import { render, staticRenderFns } from "./FormSubmitPopupMessage.vue?vue&type=template&id=4290bdfc&scoped=true&"
import script from "./FormSubmitPopupMessage.vue?vue&type=script&lang=js&"
export * from "./FormSubmitPopupMessage.vue?vue&type=script&lang=js&"
import style0 from "./FormSubmitPopupMessage.vue?vue&type=style&index=0&id=4290bdfc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4290bdfc",
  null
  
)

export default component.exports